import React from 'react';
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        minWidth: '300px',
        width: '85%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        maxWidth: '500px',
        flexDirection: 'column'
    },
    overlay: {
        zIndex: 10,
        backgroundColor: 'rgba(15, 23, 42, 0.28)',
        backdropFilter: 'blur(5px)',
        WebkitBackdropFilter: 'blur(5px)',
    }
}

const ModalComponent = ({ showModal, setShowModal, children, contentStyle = {}, contentClassName = '', overlayClassName = '' }) => {

    Modal.setAppElement('#root')

    return (
        <Modal
            isOpen={showModal}
            onRequestClose={() => setShowModal(false)}
            overlayClassName={overlayClassName || undefined}
            contentRef={(node) => {
                if (node && contentClassName) {
                    node.classList.add(contentClassName)
                }
            }}
            style={{
                ...customStyles,
                content: {
                    ...customStyles.content,
                    ...contentStyle,
                }
            }}
            contentLabel="Example Modal">
            {children}
        </Modal>
    );
}

export default ModalComponent
